import React, { useMemo, useState, useEffect, useCallback } from "react";
import MaterialReactTable from "material-react-table";
import axios from "axios";
import ReactModal from "react-modal";
import Cookies from "universal-cookie";
import * as IoIcons from "react-icons/io";
import {
  obtenerGerentes,
  obtenerRepresentanteLegal,
} from "../../Services/Rest";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { Box, IconButton, Tooltip } from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import Swal from "sweetalert2";

const cookie = new Cookies();

const grupos = ["1", "2", "3"];
const GerenteAdmin = (props) => {
  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "Id",
        filterVariant: "text",
        enableEditing: false, //disable editing on this column
      },
      {
        accessorKey: "nombreInstitucion",
        header: "Institucion",
        filterVariant: "text",
        enableEditing: false, //disable editing on this column
      },
      {
        accessorKey: "nombre",
        header: "Nombre",
        filterVariant: "text",
        //disable editing on this column
      },

      {
        accessorKey: "tipo_Documento",
        header: "Tipo Documento",
        filterVariant: "text",
        //disable editing on this column
      },
      {
        accessorKey: "telefono_Contacto",
        header: "Telefono Contacto",
        filterVariant: "text",
      },
      {
        accessorKey: "ciudad",
        header: "Ciudad",
        filterVariant: "text",
      },
      {
        accessorKey: "direccion",
        header: "Direccion",
        filterVariant: "text",
      },
      {
        accessorKey: "correo",
        header: "Correo",
        filterVariant: "text",
      },
    ],
    [],
  );

  const cookie = new Cookies();

  const [list1, setList1] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: obtenerGerentes,
    })
      .then((Response) => {
        setList1(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList1]);

  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [tableData, setTableData] = useState(() => list1);
  const handleSaveRow = async ({ exitEditingMode, row, values }) => {
    axios({
      method: "put",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ActualizaGerente?Id=" +
        values.id,
      data: values,
    })
      .then((Response) => {
        alert("Actualizado con exito!");
        window.location.reload("/");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al Actualizar" + error);
      });
    //send/receive api updates here
    setTableData([...tableData]);
    exitEditingMode(); //required to exit editing mode
  };
  const handleDeleteRow = useCallback((row) => {});
  return (
    <div>
      <div className="container">
        <div className="text-center">
          <div className="container-fluid">
            <div className="card shadow mb-4">
              <div className="card-header py-3">
                <h6 className="m-0 font-weight-bold text-primary">
                  Información Gerentes
                </h6>
                <div className="row"></div>
                <hr />
                {cookie.get("tipo_Usuario") == 1 ? (
                  <MaterialReactTable
                    localization={MRT_Localization_ES}
                    columns={columns}
                    data={list1}
                    initialState={{ showColumnFilters: true }}
                    enableRowActions
                    editingMode="modal" //default
                    enableEditing
                    onEditingRowSave={handleSaveRow}
                    renderRowActions={({ row, table }) => (
                      <Box sx={{ display: "flex", gap: "1rem" }}>
                        <Tooltip arrow placement="left" title="Edit">
                          <IconButton onClick={() => table.setEditingRow(row)}>
                            <Edit />
                          </IconButton>
                        </Tooltip>
                        <Tooltip arrow placement="right" title="Delete">
                          <IconButton
                            color="error"
                            onClick={() => handleDeleteRow(row)}
                          >
                            <Delete />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    )}
                  />
                ) : (
                  <h1></h1>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GerenteAdmin;
